<template>
  <header  class="view-head">
     <a href="/" class="logo">
        <img
          src="@/assets/images/logo-anchor.png"
          alt="Logo Jaeger-Lecoultre">
     </a>
    <lang />
  </header>
</template>

<script>

import Lang from '@/components/components/Lang.vue';
// import Loader from '@/components/components/Loader.vue';

export default {
  components: {
    // Loader,
    Lang,
  },
  computed: {
    lang() {
      return this.$store.state.user.lang || 'ko'
    },
    content() {
      return this.$store.state.exhibitions.item;
    },
    loading() {
      return this.$store.state.exhibitions.requests !== 0;
    }
  },
}
</script>

<style lang="scss" scoped>
  .view {
    /* padding-top: 65px; */
    &-head {
      position: fixed;
      top: 0;
      left: 50%;
      z-index: 2;
      width: 100%;
      max-width: 640px;
      background-color: $primary;
      display: flex;
      justify-content: space-between;

      padding: 0px 20px;
      transform: translateX(-50%);
      .logo {
        @include size(46px,46px);
        img {
          @include size(100%);
          object-fit: cover;
        }
      }
      &-title {
        @include margin(null null 20px);
        font-size: rem(37px);
      }
      &-tagline {
        @include font('primary', 'regular');
        display: block;
        font-size: rem(12px);
      }
      /* .lang {
        @include position(absolute, 25px 20px null null);
      } */
      &-title {
        @include margin(null null 10px);
        line-height: 1.1;
      }
      &-text {
        color: rgba($tertiary, .5);
      }
      .btn.transparent {
        @include margin(10px null null);
        display: block;
        width: 100%;
      }
    }
  }
</style>